export default {
  女装: "女裝",
  男装: "男裝",
  手机和小工具: "手機和小工具",
  居家生活: "居家生活",
  电脑及周边设备: "電腦及週邊設備",
  美容及个人护理: "美容及個人護理",
  家用电器: "家用電器",
  健康与保健: "健康與保健",
  食品和饮料: "食品和飲料",
  玩具_儿童和婴儿: "玩具、兒童和嬰兒",
  童装时尚: "童裝時尚",
  视频游戏: "電玩遊戲",
  运动与户外: "運動與戶外",
  爱好与书籍: "嗜好與書籍",
  相机和无人机: "相機和無人機",
  宠物食品及用品: "寵物食品及用品",
  女士包袋: "女士包袋",
  男士包袋: "男士包袋",
  珠宝及配饰: "珠寶及配件",
  手表: "手錶",
  女鞋: "女鞋",
  男装鞋: "男裝鞋",
  汽车: "汽車",
  我附近的ShopeePay: "我附近的 ShopeePay",
  餐饮_旅行和服务: "餐飲、旅遊和服務",
  旅行及行李: "旅行及行李",
  各种各样的: "各種各樣的",
  我是来买什么的: "我是來買什麼的",
  对不起_找不到_相关的商品: "對不起，找不到[{0}]相關的商品",
  类别: "類別",
  产品: "產品",
  店铺: "店鋪",
  首页: "首頁",
  限时秒杀: "限時秒殺",
  博客: "部落格",
  所有品牌: "所有品牌",
  所有类别: "所有類別",
  我的购物车: "我的購物車",
  发货信息: "出貨資訊",
  交货信息: "交貨資訊",
  付款: "付款",
  确认: "確認",
  您的购物车是空的: "您的購物車是空的",
  价格: "價格",
  税: "稅",
  数量: "數量",
  总计: "總計",
  移除: "移除",
  返回商店: "返回商店",
  继续发货: "繼續出貨",
  筛选: "篩選",
  价格范围: "價格範圍",
  排序方式: "排序方式",
  最新: "最新",
  最旧: "最舊",
  价格从低到高: "價格從低到高",
  价格从高到低: "價格從高到低",
  选择交货类型: "選擇交貨類型",
  送货上门: "送貨上門",
  继续付款: "繼續付款",
  任何其他信息: "任何其他信息",
  或者: "或者",
  您的钱包余额: "您的錢包餘額",
  余额不足: "餘額不足",
  支付: "支付",
  我同意: "我同意",
  条款和条件: "條款與條件",
  退货政策: "退貨政策",
  隐私政策: "隱私權政策",
  概括: "概括",
  项目: "專案",
  全部的: "全部的",
  小计: "小計",
  总运费: "總運費",
  有优惠码吗_在这里输入: "有優惠碼嗎？ 在這裡輸入",
  申请: "申請",
  编辑: "編輯",
  删除: "刪除",
  添加新地址: "新增地址",
  继续交货信息: "繼續交貨訊息",
  选择一个地址: "選擇一個地址",
  购买历史: "購買歷史",
  下载: "下載",
  已发送退款请求: "已發送退款請求",
  对比: "對比",
  对话: "對話",
  我的钱包: "我的錢包",
  工单: "工單",
  管理个人资料: "管理個人資料",
  登出: "登出",
  重置对比列表: "重置對比列表",
  您的对比列表为空: "您的對比清單為空",
  在您的购物车中: "在您的購物車中",
  在您的愿望清单中: "在您的願望清單中",
  在您的预定列表中: "在您的預定清單中",
  下载您的产品: "下載您的產品",
  选项: "選項",
  什么都没找到: "什麼都沒找到",
  特色产品: "特色產品",
  最畅销: "最暢銷",
  前_名: "前{0}名",
  查看更多: "看更多",
  查看所有类别: "查看所有類別",
  十大品牌: "十大品牌",
  查看所有品牌: "查看所有品牌",
  登录: "登陸",
  手机号码: "手機號碼",
  密码: "密碼",
  密码长度为6到16个字符: "密碼長度為6到16個字符",
  验证码: "驗證碼",
  登录中: "登陸中",
  游客登录: "遊客登陸",
  注册您的商店: "註冊您的商店",
  现在申请: "現在申請",
  成为商家: "成為商家",
  现在注册: "現在註冊",
  登录成功: "登陸成功",
  通知: "通知",
  未找到通知: "未找到通知",
  评论: "評論",
  估计运输时间: "估計運輸時間",
  天: "天",
  所售: "所售",
  给商家留言: "給商家留言",
  规格: "規格",
  库存: "庫存",
  总价: "總價",
  添加到购物车: "加入購物車",
  立即购买: "立即購買",
  缺货: "缺貨",
  添加到愿望清单: "加入願望清單",
  加入对比列表: "加入對比列表",
  退款: "退款",
  查看条款: "查看條款",
  分享: "分享",
  描述: "描述",
  相关产品: "相關產品",
  没有人问过商家: "沒有人問過商家",
  该产品暂无评论: "該商品暫無評論",
  客户评论: "顧客評論",
  访问商店: "訪問商店",
  畅销产品: "暢銷產品",
  日期: "日期",
  订单编号: "訂單編號",
  总额: "總額",
  状态: "狀態",
  愿望清单: "願望清單",
  还没有添加任何东西: "還沒有添加任何東西",
  注册: "註冊",
  邀请码: "邀請碼",
  请输入邀请码: "請輸入邀請碼",
  用户名: "使用者名稱",
  请输入用户名: "請輸入使用者名稱",
  用户名长度为6_14个字符: "使用者名稱長度為6-14個字符",
  昵称: "暱稱",
  请输入手机号码: "請輸入手機號碼",
  手机号码格式错误: "手機號碼格式錯誤",
  密码长度为6_16个字符: "密碼長度為6-16個字符",
  确认密码: "確認密碼",
  请输入确认密码: "請輸入確認密碼",
  提款密码: "提款密碼",
  请输入提款密码: "請輸入提款密碼",
  提款密码长度为4_16个字符: "提款密碼長度為4-16個字符",
  请输入验证码: "請輸入驗證碼",
  在_s后发送: "在{0}s後發送",
  发送验证码: "發送驗證碼",
  注册即表示您同意我们的条款和条件: "註冊即表示您同意我們的條款和條件。",
  创建账号: "建立帳號",
  验证码发送成功: "驗證碼發送成功",
  确认密码不一致: "確認密碼不一致",
  提款密码必须为数字: "提款密碼必須為數字",
  注册成功: "註冊成功",
  购物车: "購物車",
  账户: "帳戶",
  我的账户: "我的帳戶",
  已经有一个账户: "已經有帳戶",
  新地址: "新地址",
  编辑地址: "編輯地址",
  保存: "儲存",
  是否默认: "是否預設",
  具体地址: "具體地址",
  请输入具体地址: "請輸入特定地址",
  地区: "地區",
  请输入地区: "請輸入地區",
  城市: "城市",
  请输入城市: "請輸入城市",
  省份: "省份",
  请输入省份: "請輸入省份",
  邮政编码: "郵遞區號",
  请输入邮政编码: "請輸入郵遞區號",
  电话号码: "電話號碼",
  请输入电话号码: "請輸入電話號碼",
  收货人: "收貨人",
  请输入收货人: "請輸入收貨人",
  保存成功: "保存成功",
  最畅销的商家: "最暢銷的商家",
  查看所有的商家: "查看所有的商家",
  支持政策: "支持政策",
  您的电子邮件地址: "您的電子郵件地址",
  订阅: "訂閱",
  联系方式: "聯絡方式",
  地址: "地址",
  美国伊利诺伊州霍夫曼庄园: "美國伊利諾州霍夫曼莊園",
  快速链接: "快速連結",
  商家政策: "商家政策",
  submit: "提交",
  提款银行卡: "提款銀行卡",
  我的面板: "我的面板",
  提示: "提示",
  确定登出吗: "確定登出嗎",
  确定: "確定",
  取消: "取消",
  项目添加到您的购物车: "項目加入您的購物車",
  经常一起购买: "經常一起購買",
  返回购物: "返回購物",
  进行结算: "進行結算",
  帮助热线: "求助專線",
  查看所有通知: "查看所有通知",
  请输入密码: "請輸入密碼",
  前往充值: "前往儲值",
  购物车物品: "購物車物品",
  查看购物车: "查看購物車",
  钱包余额: "錢包餘額",
  充值钱包: "儲值錢包",
  钱包充值_线下_: "錢包儲值(線下)",
  申请提款: "申請提款",
  钱包收支明细: "錢包收支明細",
  批准: "核准",
  提现历史记录: "提現歷史記錄",
  类型: "類型",
  信息: "資訊",
  付款方式: "付款方式",
  请选择付款方式: "請選擇付款方式",
  Bill_Type_RECHARGE_BACK: "後台儲值",
  Bill_Type_RECHARGE_ONLINE: "線上儲值",
  Bill_Type_RECHARGE_REGISTER: "註冊贈送",
  Bill_Type_RECHARGE_JACKPOT: "儲值彩金",
  Bill_Type_RECHARGE_PRESENT: "儲值獎勵",
  Bill_Type_RECHARGE_FROM_COMMISSION: "佣金轉入",
  Bill_Type_RECHARGE_TG_COMMISSION: "儲值推廣佣金",
  Bill_Type_REGISTER_TG_COMMISSION: "註冊推廣佣金",
  Bill_Type_WITHDRAW: "提現",
  Bill_Type_WITHDRAW_REJECT: "提現駁回",
  Bill_Type_DEDUCT_HANDLE: "手動扣款",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "儲值校正",
  Bill_Type_MINING_PROFIT: "挖礦收益",
  Bill_Type_MINING_PROFIT_COMMISSION: "挖礦收益推廣佣金",
  Bill_Type_VIP_UPGRADE: "升級VIP",
  Bill_Type_FINANCE_BUY: "理財產品購買",
  Bill_Type_FINANCE_CAPITAL_RETURN: "理財餘額退回",
  Bill_Type_FINANCE_FEE: "理財手續費",
  Bill_Type_FINANCE_PROFIT: "理財收益",
  Bill_Type_FINANCE_BUY_COMMISSION: "理財產品購買佣金",
  Bill_Type_FINANCE_PROFIT_COMMISSION: "理財產品收益佣金",
  Bill_Type_WHEEL_DRAW: "大轉盤抽獎",
  Bill_Type_BUY: "購買商品",
  Bill_Type_PAY_SHOP: "支付出貨費用",
  Bill_Type_BUY_COMMISSION: "購買商品佣金",
  Bill_Type_DEPOSIT: "繳保證金",
  Bill_Type_STORE_BUY: "購買商品",
  Bill_Type_STORE_BUY_REFUND: "購買商品退款",
  Bill_Type: "帳變類型",
  Before_Money: "之前金額",
  Deal_Money: "帳變金額",
  After_Money: "之後金額",
  Bill_Time: "帳變時間",
  No_More_Data: "沒有更多數據",
  Apply_Money: "申請金額",
  Apply_Time: "申請時間",
  Withdraw_Info: "手續費：{fee}，到帳：{money}",
  提款订单状态_CHECKING: "待審核",
  提款订单状态_TRANSFERRING: "轉帳中",
  提款订单状态_PASS: "已確認",
  提款订单状态_REJECT: "已駁回",
  暂无可用充值方式: "暫無可用儲值方式",
  钱包收款码: "錢包收款碼",
  钱包地址: "錢包地址",
  金额限制: "金額限制",
  复制: "複製",
  付款凭证: "付款憑證",
  收款银行: "收款銀行",
  收款人: "收款人",
  收款账号: "收款帳號",
  付款银行: "付款銀行",
  付款人: "付款人",
  付款账号: "付款帳號",
  请输入付款银行: "請輸入付款銀行",
  请输入付款人: "請輸入付款人",
  请输入付款账号: "請輸入付款帳號",
  请上传付款凭证: "請上傳付款憑證",
  充值金额: "儲值金額",
  请输入充值金额: "請輸入儲值金額",
  submitting: "提交中...",
  Confirm: "提交",
  Commit_Success: "提交成功",
  balanceType_BALANCE: "餘額",
  balanceType_COMMISSION: "佣金",
  Balance: "帳戶餘額",
  Wash_Money: "打碼",
  请选择银行账户: "請選擇銀行帳戶",
  卡号类型: "卡號類型",
  提现金额: "提現金額",
  提款金额: "提款金額",
  不能为空: "不能為空",
  金额不正确: "金額不正確",
  please_input_withdraw_password: "請輸入提款密碼",
  withdraw_password_format_error: "提款密碼必須是4-16位元字符",
  Fee: "手續費",
  实际到账: "實際到帳",
  交易币种: "交易幣種",
  原始密码: "原始密碼",
  confirm_password_error: "兩次輸入的密碼不正確",
  save_success: "保存成功",
  please_input: "請輸入",
  old_password: "舊密碼",
  new_password: "新密碼",
  please_input_confirm_password: "請再次確認密碼",
  没有找到符合条件的商品: "沒有找到符合條件的商品",
  Search: "搜尋",
  全部: "全部",
  EnumGoodsOrderState_USER_PAY: "待配送",
  EnumGoodsOrderState_SHOP_PAY: "配送中",
  EnumGoodsOrderState_SUCCESS: "完成",
  EnumGoodsOrderState_CANCEL: "已取消",
  EnumGoodsOrderState_REFUND_SUCCESS: "已退款",
  订单号: "訂單編號",
  用户名称: "使用者名稱",
  收益: "效益",
  支付时间: "支付時間",
  配送时间: "配送時間",
  完成时间: "完成時間",
  发货: "出貨",
  全选: "全選",
  物品已添加到愿望清单: "物品已添加到願望清單",
  物品已添加到比较列表: "物品已新增至比較列表",
  购买成功提示: "恭喜您，購買成功",
  订单列表: "訂單列表",
  商品名: "商品名",
  图片: "圖片",
  没有品牌: "沒有品牌",
  基本信息: "基本訊息",
  Account_Name: "開戶姓名",
  Bank_Account: "銀行帳戶",
  Bank_Phone: "預約手機號",
  IFSC: "IFSC帳號",
  UPI: "UPI帳號",
  PIX: "PIX帳號",
  CPF: "CPF帳號",
  GCASH: "GCASH帳號",
  POWWI: "POWWI帳號",
  身份证号: "身分證號",
  Edit: "修改",
  Delete: "刪除",
  Add: "新增",
  Forget_Withdraw_Password: "忘記提款密碼",
  Bank_Card_Info: "金融卡資訊",
  收款人地址: "收款人地址",
  SWIFT: "SWIFT",
  Bank_Branch: "分行名稱",
  分行代码: "分行代碼",
  银行地址: "銀行地址",
  Email: "Email",
  银行卡长度必须超过: "銀行卡長度必須超過{length}",
  银行卡格式不正确: "金融卡格式不正確",
  Do_you_confirm_delete: "是否確認刪除？",
  Please_Login_First: "請先登入",
  Bank_Name: "銀行名稱",
  Please_add_bank_first: "您尚未綁定銀行卡，請先新增",
  withdrawType: "提款類型",
  withdraw_money_limit: "提款金額必須大於0且小於或等於{balance}",
  withdraw_times_limit:
    "您今日提取了{todayWithdrawNum}次，在{limitTimes}次之後將收取{withdrawFee}％的手續費。 是否確定提款？",
  Copy_Success: "複製成功",
  商店首页: "商店首頁",
  所有产品: "所有產品",
  新到货产品: "新到貨產品",
  所有商家: "所有商家",
  请上传: "請上傳",
  请输入: "請輸入",
  忘记密码: "忘記密碼",
  记得我: "記得我",
  共_件: "共{0}件",
  取消订单: "取消訂單",
  申请退款: "申請退款",
  未知商家: "未知商家",
  到账: "到帳",
  提款订单状态: "提款訂單狀態",
  前_名类别: "前{0}名類別",
  取消订单原因_不想要了: "不想要了",
  取消订单原因_商品错选_多选: "商品錯選/多選",
  取消订单原因_商品无货: "商品無貨",
  取消订单原因_地址信息填写错误: "地址資訊填寫錯誤",
  取消订单原因_商品降价: "商品降價",
  取消订单原因_价格高于其他平台: "價格高於其他平台",
  取消订单原因_没用_少用_错用优惠: "沒用/少用/錯用優惠",
  退款原因_拍错_多拍_不喜欢: "拍錯/多拍/不喜歡",
  退款原因_商品成分描述不符: "商品成分描述不符",
  退款原因_与商家协商一致退款: "與商家協商一致退款",
  退款原因_生产日期_保质期与商品描述不符: "生產日期/保存期限與商品描述不符",
  退款原因_图片_产地_批号_规格等描述不符: "圖片/產地/批號/規格等描述不符",
  退款原因_质量问题: "品質問題",
  退款原因_商品变质_发霉_有异物: "商品變質/發黴/有異物",
  退款原因_少件_含缺少配件_: "少件（含缺少配件）",
  退款原因_收到商品时有破损_污渍_变形: "收到商品時有破損/污漬/變形",
  退款原因_假冒品牌: "仿冒品牌",
  退款原因_发票问题: "發票問題",
  退款原因_商家发错货: "商家寄錯貨",
  退款原因_预约不到_商家不给退换: "預約不到/商家不給退換",
  退款失败: "退款失敗",
  退款处理中: "退款處理中",
  默认: "預設",
  产品查询: "產品查詢",
  商店LOGO: "商店LOGO",
  推广码: "推廣碼",
  查看所有: "看全部",
  确认收货成功: "確認收貨成功",
  物流公司: "物流公司",
  物流单号: "物流單號",
  发货时间: "出貨時間",
  请先选择商品规格: "請先選擇商品規格",
  个人信息: "個人資訊",
  您的用户名: "您的使用者名稱",
  你的名字: "你的名字",
  登录名: "使用者名稱",
  你的邮件: "你的郵件",
  你的密码: "你的密碼",
  重复输入密码: "重複輸入密碼",
  店铺名称: "店家名稱",
  证书类型: "證書類型",
  身份证: "身分證",
  护照: "護照",
  驾驶执照: "駕駛執照",
  社会保障卡: "社會安全卡",
  证书正面: "證書正面",
  证书反面: "憑證反面",
  确认收货: "確認收貨",
  请选择取消订单的原因必选: "請選擇取消訂單的原因（必選）:",
  请选择申请退款的原因必选: "請選擇申請退款的原因（必選）:",
  留言: "留言",
  请输入留言: "請輸入留言",
  没有帐户: "沒有帳戶",
  钱包充值: "錢包儲值",
  输入您的文字: "輸入您的文字",
  商家登录: "商家登入",
  有关此产品的任何查询: "有關此產品的任何查詢",
  产品名称: "產品名稱",
  你的问题: "你的問題",
  白银店铺: "白銀店鋪",
  铂金店铺: "鉑金店鋪",
  钻石店铺: "鑽石店鋪",
  照片: "照片",
  已退货: "已退貨",
  邮寄状态: "郵寄狀態",
  订单摘要: "訂單摘要",
  收件地址: "收件地址",
  订购日期: "訂購日期",
  订单状态: "訂單狀態",
  总订单金额: "總訂單金額",
  邮寄方式: "郵寄方式",
  附加信息: "附加資訊",
  订单详细信息: "訂單詳細信息",
  交货类型: "交貨類型",
  进行评论: "進行評論",
  已评论: "已評論",
  订单金额: "訂單金額",
  优惠券: "優惠券",
  统一运费: "統一運費",
  送货地址: "送貨地址",
  评分: "評分",
  你的意见: "你的意見",
  匿名: "匿名",
  现金: "現金",
  详情: "詳情",
  收货地址: "收貨地址",
  暂时没有对话: "暫時沒有對話",
  你: "你",
  输入您的回复: "輸入您的回复",
  删除成功: "刪除成功",
  品牌: "品牌",
  已缴纳的保证金: "已繳交的保證金",
  黄金店铺: "黃金店鋪",
  没有更多数据: "沒有更多數據",
  站内信: "站內信",
  系统通知: "系統通知",
  邮箱: "信箱",
  手机号: "手機號",
  你的手机号: "你的手機號",
  营业执照: "營業執照",
  你的邮箱: "你的信箱",
  搜索结果: "搜尋結果",
  系统公告: "系統公告",
  客服: "客服",
  税号: "稅號",
  订单: "訂單",
  合计: "合計",
  系统安全: "系統安全",
  Recharge_Money_Limit: "儲值金額必須在{min}和{max}之間",
  限时优惠: "限時優惠",
  高价回收: "高價回收",
  姓名: "姓名",
  商品订单号: "商品訂單編號",
  商品在线回收: "商品線上回收",
  提交: "提交",
  回收记录: "回收記錄",
  回收状态: "回收狀態",
  回收价格: "回收價格",
  纳税码: "納稅碼",
  买家登录: "登入",
  买家注册: "註冊",
  language: "繁体",
  消息已撤回: "消息已撤回",
  物流详情: "物流詳情",
  充值: "儲值",
  提现: "提現",
  信用分: "信用分",
  余额: "餘額",
  佣金: "佣金",
  继续购物: "繼續購物",
  订单结算: "訂單結算",
  加入对比: "加入對比",
  佣金余额: "佣金餘額",
  刷新: "重新整理",
  刷新成功: "刷新成功",
  官网: "官網",
  助力提示:
    "為商戶助力可提昇平台對其店舖的曝光度，累計助力天數越高曝光量越高。",
  已累计助力: "已累計助力",
  今日已助力: "今日已助力",
  立即助力: "立即助力",
  商家助力: "商家助力",
  证件号码: "證件號碼",
  证书号码: "證書號碼",
  男鞋: "男鞋",
  游戏玩具: "遊戲玩具",
  使用条款: "使用條款",
  商家: "商家",
  已助力: "已助力",
  被助力: "被助力",
  用户: "用戶",
  助力记录: "助力記錄",
  消息类型: "消息類型",
  消息内容: "消息內容",
  链接: "鏈接",
  文本: "文字",
  清空: "清空",
  评论成功: "評論成功",
  扫描二维码: "掃描二維碼",
  转入: "轉入",
  收款: "收款",
  任务下单中心: "任務下單中心",
  记录: "記錄",
  任务倒计时: "任務倒數計時",
  倒计时后自动放弃: "倒數計時後自動放棄",
  业务码: "業務碼",
  选择商品分类: "選擇商品分類",
  可多选: "可多選",
  加载分类中: "載入分類中",
  暂无分类: "暫無分類",
  产品类别: "產品類別",
  账户余额: "帳戶餘額",
  立即结算: "立即結算",
  任务已自动放弃: "任務已自動放棄",
  商品分类: "商品分類",
  订单详情: "訂單詳情",
  预计收益: "預計收益",
  预计佣金收益: "預計佣金收益",
  收益率: "殖利率",
  扣款账户: "扣款帳戶",
  确认结算: "確認結算",
  未选择: "未選擇",
  请选择商品分类: "請選擇商品分類",
  下单成功: "下單成功",
  下单失败: "下單失敗",
  请重试: "請重試",
  订单记录: "訂單記錄",
  没有更多了: "沒有更多了",
  业务号: "業務號",
  商品类型: "商品類型",
  佣金收益: "佣金收益",
  待结算: "待結算",
  已结算: "已結算",
  已取消: "已取消",
  加载失败: "載入失敗",
  倒计时: "倒數計時",
  随机商品: "随机商品",
  为: "為",
  商户助力可提升商品曝光度: "商家協助可提升商品曝光度",
  累计助力越高推荐权重越高: "累計助力越高推薦權重越高",
  实时助力动态: "实时助力动态",
  助力奖励: "助力奖励",
  随机奖励金额已生成: "隨機獎勵金額已生成",
  开心收下: "开心收下",
  助力已结束: "助力已结束",
  助力成功: "助力成功",
  成功: "成功",
  进行中: "進行中",
  等待: "等待",
  助力失败: "助力失败",
  任務: "任務",
  下单失败_请稍后重试: "下單失敗，請稍後重試",
  任务: "任務"
};
